module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.data) ? _c('crud-table', {
    attrs: {
      "flat": "",
      "headers": _vm.data.headers,
      "deleteable": true,
      "items": _vm.data.data,
      "loading": _vm.getProductsRequest.loading,
      "no-data-text": "No products found for this appointment",
      "empty-btn-text": "Add a product"
    },
    on: {
      "add": _vm.addProduct,
      "edit": _vm.editProduct,
      "delete": _vm.deleteProduct
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b40a382","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/AppointmentProduct.vue
// module id = 1418
// module chunks = 9